/* Setup tinymce editor */
const tinymce = {
    loadScripts: async function () {
        const scriptLoaded = document.getElementById("tinymceScript");
        if (!scriptLoaded) {
            let script = document.createElement("script");
            script.setAttribute("id", "tinymceScript");
            script.setAttribute("type", "text/javascript");
            script.setAttribute("referrerPolicy", "origin");
            script.src = "https://stage-assets.autoalert.com/js/root/tinymce/tinymce.min.js";
            script.onload = () => {
                // console.log("TinyMCE script loaded");
                this.loadPluginScripts();
            }
            let bodyElements = document.getElementsByTagName("body");
            if (bodyElements && bodyElements.length > 0) bodyElements[0].appendChild(script);
        }
    },
    loadPluginScripts: async function () {
        let bodyElements = document.getElementsByTagName("body");
        if (bodyElements && bodyElements.length > 0) {
            ["emoticons", "code", "link"].forEach(plugin => {
                let tinymcePlugin = document.createElement("script");
                tinymcePlugin.type = "text/javascript";
                tinymcePlugin.referrerPolicy = "origin";
                tinymcePlugin.src = `https://stage-assets.autoalert.com/js/root/tinymce/plugins/${plugin}/plugin.min.js`;
                bodyElements[0].appendChild(tinymcePlugin);
            });
        }
    }
};

export default tinymce;


// WEBPACK FOOTER //
// ./src/lib/tinymce/tinymce.js